
export default {
  head: {
    bodyAttrs: {
      class: 'disable-scroll-chaining'
    }
  }
}
